import { createFileRoute } from '@tanstack/react-router';
import { AnomaliesPage } from '@/pages/AnomaliesPage';

export const Route = createFileRoute('/_authed/anomalies')({
  component: AnomaliesPage,
});
